export type MapTileServer = "osm_de" | "osm_org" | "osm_bright" | "alidade_smooth" | "world_topo_map";

export interface MapOptions {
    center?: L.LatLngExpression;
    zoom?: number;
    bounds?: L.LatLngBounds;
    tileServer?: MapTileServer;
    supportPrint?: boolean;
}

export class Map {

    public map: L.Map;

    constructor(public element: HTMLDivElement, options: MapOptions = {}) {

        options = e5.ObjectUtil.extend({
            center: [53.53169678559957, 8.587563427419155],
            zoom: 11,
            tileServer: "osm_de"
        } as MapOptions, options);

        // L.Map.include({
        //     latLngToLayerPoint: function (latlng) {
        //         var projectedPoint = this.project(L.latLng(latlng)); // no round()
        //         return projectedPoint._subtract(this.getPixelOrigin());
        //     },
        // });

        this.map = L.map(element);

        if (options.bounds) {
            if (options.bounds.getNorthEast().equals(options.bounds.getSouthWest())) {
                this.map.setView(options.bounds.getNorthEast(), options.zoom);
            } else {
                this.map.fitBounds(options.bounds, { paddingTopLeft: [20, 50], paddingBottomRight: [20, 20] });
            }
        } else {
            this.map.setView(options.center, options.zoom);
        }


        if (options.tileServer === "osm_org") {
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(this.map);
        }
        else if (options.tileServer === "osm_de") {
            L.tileLayer('https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png', {
                maxZoom: 18,
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(this.map);
        }
        else if (options.tileServer === "alidade_smooth") {
            L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png', {
                maxZoom: 20,
                attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
            }).addTo(this.map);
        }
        else if (options.tileServer === "osm_bright") {
            L.tileLayer('https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png', {
                maxZoom: 20,
                attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
            }).addTo(this.map);
        }
        else if (options.tileServer === "world_topo_map") {
            // L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
            //     attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
            // }).addTo(this.map);

            L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
                attribution: 'Tiles &copy; Esri',
                detectRetina: false
            }).addTo(this.map);
        }
        else {
            L.tileLayer('https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png', {
                maxZoom: 18,
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(this.map);
        }

        if (window.matchMedia) {
            var mediaQueryList = window.matchMedia('print');
            if (mediaQueryList.addEventListener) {
                mediaQueryList.addEventListener("change",
                    (mql) => {
                        // this.printResize("matchMedia");
                        this.resize();

                        if (mql.matches) {
                            // console.log('onbeforeprint equivalent');
                        } else {
                            // console.log('onafterprint equivalent');
                        }
                    });
            }
        }

        window.addEventListener("beforeprint", (e) => {
            this.element.classList.add("e5-immo-detail__map-container--print");
            this.printResize("beforeprint");
        });

        window.addEventListener("afterprint", (e) => {
            this.element.style.width = null;
            this.element.classList.remove("e5-immo-detail__map-container--print");
            this.printResize("afterprint");
        });

        // var resize = e5.Resize.create(this.element);
        // resize.add(() => {
        //     this.resize();
        // });
    }

    private printResize(reason: string): void {
        // console.log("PRINT RESIZE", reason, window.innerWidth);
        this.resize();
    }

    public show(latLng: L.LatLngExpression, bounds: L.LatLngBounds = null): void {

        var zoom = 17;
        if (bounds) {
            zoom = this.map.getBoundsZoom(bounds, false, L.point(20, 20));
        }

        this.map.panTo(latLng, { animate: false });
        if (this.map.getZoom() < zoom) {
            this.map.setZoom(zoom, { animate: false });
        }
    }

    public resize(): void {
        this.map.invalidateSize(false);
    }
}